// extracted by mini-css-extract-plugin
export default {"wrapper":"AddProduct_wrapper__rMs7U","container-main":"AddProduct_container-main__msDEb","form":"AddProduct_form__brE0K","buttons":"AddProduct_buttons__FnSI3"};